import React from 'react';
import classnames from 'classnames';
import styles from './MultiSelect.module.css';


class MultiSelect extends React.Component {
  state ={
    selected: new Map()
  };

  onSelect = (valueId, item) => {
    const newSelected = new Map(this.state.selected);
    newSelected.set(valueId, !this.state.selected.get(valueId));
    this.setState({selected: newSelected})

    this.props.onClickMultiSelectButton(this.props.id, !this.state.selected.get(item.key), valueId, item, this.props.componentBlock)
    // this.props.changeData(this.props.id, !this.state.selected.get(item.key), valueId, item, this.props.componentBlock)
  };

  render() {
    const {componentBlock, contentData, id, changeData, title} = this.props;

    return(
      <div
        className={classnames({
          [styles.wrap]: componentBlock.visibility,
          [styles.visibility]: !componentBlock.visibility
        })}
      >
        {/*<Text*/}
        {/*  style={styles.itemTitle}*/}
        {/*>*/}
        {/*  {title}*/}
        {/*</Text>*/}
        {/*<FlatList*/}
        {/*  data={contentData}*/}
        {/*  listKey={item => item.key.toString()}*/}
        {/*  extraData={this.state.selected}*/}
        {/*  renderItem={({item}) => (*/}
        {/*    <TouchableOpacity*/}
        {/*      style={[styles.itemWrap, !!this.state.selected.get(item.key) ? styles.selectedItemWrap : styles.notSelectedItemWrap]}*/}
        {/*      onPress={()=> this.onSelect(item.key, item)}*/}
        {/*    >*/}
        {/*      <Text*/}
        {/*      style={[styles.itemText, !!this.state.selected.get(item.key) ? styles.selectedItemText : styles.notSelectedItemText]}*/}
        {/*      >*/}
        {/*        {item.item}*/}
        {/*      </Text>*/}
        {/*    </TouchableOpacity>*/}
        {/*  )}*/}
        {/*/>*/}
      </div>
    )
  }
}


// const styles = StyleSheet.create({
//   blockWrap: {
//     backgroundColor: '#f1f1f1',
//     borderRadius: 10,
//     padding: 10,
//     marginBottom: 20,
//   },
//   itemWrap: {
//     flexDirection: 'row',
//     justifyContent: 'center',
//     alignItems: 'center',
//     borderWidth: 2,
//     borderColor: '#ececec',
//     borderRadius: 20,
//     padding: 15,
//     margin: 5,
//   },
//   selectedItemWrap: {
//     backgroundColor: '#d72f2a'
//   },
//   notSelectedItemWrap: {
//     backgroundColor:'#fff'
//   },
//   itemTitle: {
//     textAlign: 'center',
//     fontFamily: 'Helvetica_Neue_Bold',
//     fontSize: 12,
//     fontWeight: '400',
//     lineHeight: 16,
//   },
//   itemText: {
//     textAlign: 'center',
//     fontFamily: 'Helvetica_Neue_Light',
//     fontSize: 12,
//     fontWeight: '400',
//     lineHeight: 16,
//   },
//   selectedItemText: {
//     color: 'white'
//   },
//   notSelectedItemText: {
//     color:'#000'
//   },
//
//
// });

export default MultiSelect;